/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/social-export-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { GetUploadByKeyQueryResponse, GetUploadByKeyPathParams } from "../models/GetUploadByKey";

export function getGetUploadByKeyUrl(key: GetUploadByKeyPathParams["key"], platform: GetUploadByKeyPathParams["platform"]) {
  const res = { method: 'GET', url: `/upload/by-key/${platform}/${key}` as const }
  return res
}

/**
 * @summary Get upload by platform and key
 * {@link /upload/by-key/:platform/:key}
 */
export async function getUploadByKey(key: GetUploadByKeyPathParams["key"], platform: GetUploadByKeyPathParams["platform"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetUploadByKeyQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetUploadByKeyUrl(key, platform).url.toString(), ... requestConfig })
  return res.data
}